import { channels } from "@/mocks/qxian";

const art: Record<string, string> = {
  娱乐八卦:
    "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20evoking%20backstage%20gossip%20buzz%2C%20warm%20vermilion%20red%20stage%20curtain%20glow%20with%20scattered%20golden%20bokeh%20and%20soft%20film%20grain%2C%20cinematic%20spotlight%2C%20moody%20charcoal%20background%2C%20stylish%20magazine%20cover%20aesthetic%2C%20no%20people%2C%20no%20text&width=600&height=600&seq=qxian-c1&orientation=squarish",
  综艺现场:
    "https://readdy.ai/api/search-image?query=Abstract%20energetic%20entertainment%20scene%20of%20warm%20amber%20and%20coral%20stage%20lights%20with%20floating%20confetti%20sparkles%20and%20light%20streaks%2C%20vibrant%20play%20show%20atmosphere%2C%20deep%20dark%20warm%20background%2C%20cinematic%20bokeh%2C%20editorial%20graphic%20style%2C%20no%20people%2C%20no%20text&width=600&height=600&seq=qxian-c2&orientation=squarish",
  品牌商务:
    "https://readdy.ai/api/search-image?query=Minimal%20abstract%20product%20packaging%20still%20life%20in%20warm%20terracotta%20and%20cream%20tones%2C%20elegant%20folded%20cardboard%20and%20soft%20shadow%20on%20clean%20backdrop%2C%20refined%20brand%20editorial%20photography%20mood%2C%20premium%20and%20calm%2C%20no%20readable%20text&width=600&height=600&seq=qxian-c3&orientation=squarish",
  圈内风向:
    "https://readdy.ai/api/search-image?query=Abstract%20backstage%20radio%20studio%20mood%20in%20warm%20amber%20glow%2C%20glowing%20microphone%20silhouette%20surrounded%20by%20soft%20vignette%20and%20dust%20light%20beams%2C%20mysterious%20insider%20atmosphere%2C%20deep%20warm%20dark%20background%2C%20cinematic%20editorial%2C%20no%20people%2C%20no%20readable%20text&width=600&height=600&seq=qxian-c4&orientation=squarish",
};

const toneRing: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function Channels() {
  return (
    <section id="channels" className="w-full bg-background-100/70 scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
            <i className="ri-grid-fill"></i>
            按兴趣进入
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">话题频道</h2>
          <p className="mt-2 text-sm text-foreground-600">
            选择你更关心的方向，进入对应频道专注跟进，快报也会按频道归类呈现。
          </p>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c) => (
            <a
              key={c.id}
              href="#live"
              className="group overflow-hidden rounded-2xl bg-background-50 border border-background-200 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={art[c.name]}
                  alt={c.name + " 频道示意图"}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                <span className={"absolute left-3 bottom-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs text-background-50 " + toneRing[c.tone]}>
                  <i className="ri-hashtag"></i>
                  {c.count.toLocaleString()} 条
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {c.name}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}